DJ.addBehavior('accordeons', '.js-accordeons', {
  attach: function(context, settings, behavior) {
    var $holder = jQuery(this);
    var $toggle = $holder.find('.accordeon-title');

    $toggle.on('click', function() {
      var $this = jQuery(this);
      var $parent = $this.parent('.accordeon');

      $holder.find('.accordeon.opened').not($parent).removeClass('opened');
      $parent.addClass('opened');

      $holder.find('.accordeon-content').not($parent.find('.accordeon-content')).slideUp(200);
      $parent.find('.accordeon-content').slideDown(200);

      $holder.find('.accordeon-image-placeholder').fadeOut(200, function () {
        jQuery(this).html(
          $parent.find('.accordeon-image').html()
        ).fadeIn(200);
      });
    });
  },

  detach: function(context, settings) {}
});
